export default {
  titles: {
    delivery_address: 'Delivery Address',
    location: 'Location',
    date_time: 'Date & Time',
  },
  subtitles: {
    delivery_address: 'Provide address to confirm delivery availability',
  },
};
